var _excluded = ["children", "id", "className", "color", "expanded", "expandedColor", "item", "onExpand", "onSelect", "select", "selected", "selectable"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import classnames from 'classnames';
import uniqueId from 'lodash.uniqueid';
import React, { useState } from 'react';
import Button from "../Button/Button";
import Collapse from "../Collapse/Collapse";
import Icon from "../Icon/Icon";
import Input from "../Input/Input";
import Label from "../Label/Label";
import ListGroupItem from "./ListGroupItem";

function ListItem(_ref) {
  var render = _ref.children,
      itemId = _ref.id,
      className = _ref.className,
      color = _ref.color,
      _ref$expanded = _ref.expanded,
      defaultExpanded = _ref$expanded === void 0 ? false : _ref$expanded,
      expandedColor = _ref.expandedColor,
      item = _ref.item,
      onExpand = _ref.onExpand,
      onSelect = _ref.onSelect,
      select = _ref.select,
      selected = _ref.selected,
      selectable = _ref.selectable,
      props = _objectWithoutProperties(_ref, _excluded);

  var isExpandable = onExpand !== undefined;
  var ExpandedItem = isExpandable ? onExpand(item) : undefined;

  var _useState = useState(defaultExpanded),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = useState(function () {
    return uniqueId('listitem-');
  }),
      _useState4 = _slicedToArray(_useState3, 1),
      id = _useState4[0];

  var unselectedColor = expanded && expandedColor || color;
  return /*#__PURE__*/React.createElement(ListGroupItem, _extends({
    color: selected ? 'primary' : unselectedColor,
    className: classnames('rounded-0', className)
  }, props), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, select && /*#__PURE__*/React.createElement("div", {
    className: "pe-2",
    style: {
      width: '26px'
    }
  }, /*#__PURE__*/React.createElement(Input, {
    id: id,
    type: select,
    checked: selected,
    label: /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "Select ", itemId),
    onChange: function onChange(e) {
      return onSelect && onSelect(item, e.target.checked);
    },
    disabled: selectable ? !selectable(item) : false
  }), /*#__PURE__*/React.createElement(Label, {
    for: id,
    className: "sr-only"
  }, "Select ", itemId)), /*#__PURE__*/React.createElement("div", {
    className: "me-auto w-100 px-2",
    style: {
      maxWidth: select ? 'calc(100% - 26px)' : '100%'
    }
  }, render(item, selected)), isExpandable && /*#__PURE__*/React.createElement(Button, {
    color: "link",
    onClick: function onClick() {
      return setExpanded(!expanded);
    },
    style: {
      visibility: ExpandedItem === undefined ? 'hidden' : 'visible'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-".concat(expanded ? 'up' : 'down')
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Expand ", itemId))), ExpandedItem === undefined || /*#__PURE__*/React.createElement(Collapse, {
    isOpen: expanded
  }, ExpandedItem));
}

ListItem.displayName = "ListItem";
ListItem.displayName = 'ListItem';
export default ListItem;